// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__bJPzb","name":"Header_name__17BX7","birthday":"Header_birthday__nVirk","skeleton":"Header_skeleton__2jak6"};